import { Component, OnInit, AfterViewInit, effect, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgModel, NgForm } from '@angular/forms';
import { EditProfileService } from './edit-profile.service';
import { LoginService } from '../login/login.service';
import { gigyaInfo } from '../../types/gigyaInfo';
import { RegistrationService } from '../registration/registration.service';
import { TranslateService } from '@ngx-translate/core';
import jwt_decode from 'jwt-decode';
import { JwtService } from '../../shared/services/jwt/jwt.service';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/services/popup/popup.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrl: './edit-profile.component.sass',
    standalone: false
})

export class EditProfileComponent implements OnInit {
  @ViewChild('editProfile') editProfileForm!: NgForm;
  userData: any;
  response: any;
  countryList: any;
  diallingCode: any;
  deliveryDiallingCode: any;
  deliveryCountryCode: any;
  countryId: any;
  deliveryCountryId: any;
  consent: any;
  deliveryCountryName = '';
  errorMessage = '';
  profileInfo: gigyaInfo = new gigyaInfo();
  vatValue = '';
  vatVerified = false;
  showVATError = true;
  vatValidateError = true;
  notValidContent = false;
  notValidDeliveryContent = false;
  accountId: any;
  initialFormData: any;
  showVatField = false;
  isLoader = false;
  eInvoice = '';
  EInvoiceValue = '';
  sirenDisabled = false;
  siretDisabled = false;
  einvoiceAddressLineVerified = false;
  einvoiceAddressLineError = false;
  einvoicingList: any[] = [
    { value: 'SR', label: 'SIREN' }, { value: 'SRST', label: 'SIREN+SIRET' }, 
    { value: 'SRSTRC', label: 'SIREN+SIRET+ROUTING CODE' }, { value: 'SRSF', label: 'SIREN+SUFFIX' }
  ];
  languageList: any[] = [
    { langCode: 'fr', langName: 'Français' },
    { langCode: 'en', langName: 'English' },
  ];

  @ViewChild('deliveryPostalCode') deliveryPostalCodeControl!: NgModel;

  constructor(public router: Router, private translate: TranslateService, private jwtService: JwtService,
              private registrationService: RegistrationService, private editService: EditProfileService,
              private loginService: LoginService, private popupService: PopupService,
              private cdr: ChangeDetectorRef) {
    effect(() => {
      this.userData = this.loginService.gigyaResponse;
      if(this.userData) {
        this.countryId = this.userData.countryId;
        this.deliveryCountryId = this.userData.deliveryCountryId;
        if(this.userData.personalDataAccess) {
          this.consent = 'yes';
        } else {
          this.consent = 'no';
        }
        this.accountId = this.userData.accountId;
        if(this.userData.eInvoice) {
          this.eInvoice = this.userData.eInvoice;
        } else {
          this.eInvoice = 'SR';
        }
        this.mapCurrentData(this.userData);
        this.appendToEinvoiceValue();
        this.setDiallingCodes();
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.getCountryList();
  }

  getCountryList() {
    this.isLoader = true;
    this.registrationService.getCountries().subscribe(
      (response: any) => {
        this.isLoader = false;
        let encryptData = response;
        let countryData: any = jwt_decode(encryptData);
        this.countryList = countryData.countryDetailsList;
        this.countryList = this.countryList.filter(
          (item: any) =>
            item.countryId !== 178 &&
            (item.region == 'EUR' ||
              item.countryId == 3 ||
              item.countryId == 6 ||
              item.countryId == 14 ||
              item.countryId == 28 ||
              item.countryId == 74 ||
              item.countryId == 81 ||
              item.countryId == 85 ||
              item.countryId == 88 ||
              item.countryId == 91 ||
              item.countryId == 93 ||
              item.countryId == 97 ||
              item.countryId == 103 ||
              item.countryId == 104 ||
              item.countryId == 107 ||
              item.countryId == 108 ||
              item.countryId == 123 ||
              item.countryId == 127 ||
              item.countryId == 135 ||
              item.countryId == 138 ||
              item.countryId == 142 ||
              item.countryId == 144 ||
              item.countryId == 154 ||
              item.countryId == 162 ||
              item.countryId == 180 ||
              item.countryId == 185 ||
              item.countryId == 193 ||
              item.countryId == 201 ||
              item.countryId == 211 ||
              item.countryId == 223 ||
              item.countryId == 228 ||
              item.countryId == 230 ||
              item.countryId == 243 ||
              item.countryId == 244),
        );
        this.countryList.sort((a: any, b: any) =>
          a.countryName > b.countryName ? 1 : -1,
        );
        this.setDiallingCodes();
        this.cdr.detectChanges();
      },
      (err: any) => {
        this.isLoader = false;
      },
    );
  }

  setDiallingCodes() {
    if(!this.countryList || this.countryList.length === 0) {
      return;
    }
    let index,
      delIndex = 0;
    this.countryList.forEach((item: any) => {
      if(this.countryId === item.countryId) {
        index = this.countryList.indexOf(item);
      }
      if(this.deliveryCountryId === item.countryId) {
        delIndex = this.countryList.indexOf(item);
      }
    });
    if(index !== undefined) {
      this.diallingCode = '+' + this.countryList[index].dialingCode;
    }
    if(delIndex !== undefined) {
      this.deliveryDiallingCode = '+' + this.countryList[delIndex].dialingCode;
    }
  }

  countryChange(val: any) {
    let index = 0;
    this.countryList.forEach((item: any) => {
      if(this.deliveryCountryId === item.countryId) {
        index = this.countryList.indexOf(item);
      }
    });
    this.deliveryDiallingCode = '+' + this.countryList[index].dialingCode;
    // Trigger validation on postal code field
    setTimeout(() => {
      if(this.deliveryPostalCodeControl) {
        this.deliveryPostalCodeControl.control.updateValueAndValidity();
      }
    }, 0);
  }

  mapCurrentData(userData: any) {
    this.profileInfo = Object.assign({}, userData);
    if(userData.region === 'EUR' || userData.countryId == 85 || userData.countryId == 135 || userData.countryId == 180 || userData.countryId == 142) {
      this.showVatField = true;
      this.vatValue = userData.vatNumber;
    }
    this.sirenDisabled = !!this.profileInfo.siren;
    this.siretDisabled = !!this.profileInfo.siret;
    this.initialFormData = { ...this.profileInfo };
  }

  isFormChanged(): boolean {
    const currentData = {
      ...this.profileInfo,
      deliveryCountryId: this.deliveryCountryId,
      eInvoice: this.eInvoice
    };
    const initialData = {
      ...this.initialFormData,
      deliveryCountryId: this.initialFormData.deliveryCountryId,
      eInvoice: this.initialFormData.eInvoice
    };
    return JSON.stringify(currentData) !== JSON.stringify(initialData);
  }

  submitEditProfile() {
    this.profileInfo.countryId = this.countryId;
    this.profileInfo.deliveryCountryId = this.deliveryCountryId;
    this.profileInfo.vatNumber = this.vatValue;
    this.profileInfo.eInvoice = this.eInvoice;
    if(this.consent == 'yes') {
      this.profileInfo.personalDataAccess = true;
    } else {
      this.profileInfo.personalDataAccess = false;
    }
    let profileData: string = this.jwtService.encode(this.profileInfo, 'secret');
    this.isLoader = true;
    this.editService.editUserProfile(profileData).subscribe((response: any) => {
        this.isLoader = false;
        this.response = response;
        if(this.response.error) {
          if(this.response.errorMessage === 'GSObject does not contain a value for key UID') {
            this.errorMessage = this.translate.instant('ORGADMIN_EXISTING_EMAIL_ERROR');
          } else if(this.response.errorMessage === 'SIREN Already Exists' || this.response.errorMessage === 'SIRET Already Exists') {
            this.errorMessage = this.response.errorMessage;
          } else {
            this.errorMessage = this.response.errorMessage;
          }
          this.popupService.openDialog(MessagePopupComponent, {
            data: { message: this.errorMessage },
          });
        } else {
          this.errorMessage = 'User profile details updated successfully';
          this.loginService.setGigyaResponse(this.profileInfo);
          this.popupService.openDialog(MessagePopupComponent, {
            data: { message: this.errorMessage },
          });
          this.router.navigate(['/home']);
        }
      },
      (err: any) => {
        this.isLoader = false;
      },
    );
  }

  backToHome() {
    this.router.navigateByUrl('home');
  }

  vatNumberChanged() {
    if(this.vatVerified) {
      this.vatVerified = false;
      this.showVATError = false;
    }
    if(this.vatValue !== '') {
      this.vatValidateError = false;
    }
  }

  appendToEinvoiceValue() {
    this.einvoiceAddressLineVerified = false;
    this.einvoiceAddressLineError = false;
    const siren = this.profileInfo?.siren ? String(this.profileInfo.siren) : '';
    if(!siren) {
      this.EInvoiceValue = '';
      return;
    }
    const siret = this.profileInfo.siret ? String(this.profileInfo.siret) : '';
    if(this.eInvoice === 'SRST') {
      this.EInvoiceValue = siren + '_' + siret;
    } else if(this.eInvoice === 'SRSTRC') {
      this.EInvoiceValue = siren + '_' + siret + '_' + (this.profileInfo.routingCode || '');
    } else if(this.eInvoice === 'SRSF') {
      this.EInvoiceValue = siren + '_' + (this.profileInfo.suffix || '');
    } else {
      this.EInvoiceValue = siren;
    }
  }

  validateEinvoiceAddressLine() {
      if(this.EInvoiceValue !== '') {
        
        let request: any = { einvoicingAddressLine: this.EInvoiceValue };
        let einvoiceAddressLineRequest: string = this.jwtService.encode(request, 'secret');
        this.isLoader = true;
        this.registrationService.checkEinvoiceAddressLine(einvoiceAddressLineRequest).subscribe(
          (response: any) => {
            this.isLoader = false;
            let encryptData = response;
            let einvoiceAddressLineUpdateData: any = jwt_decode(encryptData);
            this.einvoiceAddressLineVerified =
              einvoiceAddressLineUpdateData.directoryLine.status === 'Enabled';
            this.einvoiceAddressLineError = !this.einvoiceAddressLineVerified;
            this.cdr.detectChanges();
          },
          (err: any) => {
            this.isLoader = false;
            this.einvoiceAddressLineVerified = false;
            this.einvoiceAddressLineError = true;
            this.cdr.detectChanges();
          },
        );
      }
    }

  get dataPrivacyDoc(): string {
    return (
      environment.bucket_public_url +
      `DATA_PRIVACY_${this.translate.currentLang.toUpperCase()}_V1.pdf`
    );
  }

  // e-invoicing block only shows for these countries
  get showsEinvoiceSection(): boolean {
    return this.countryId === 73 || this.countryId === 85 || this.countryId === 135 || this.countryId === 180;
  }

}
